export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/th.lyaml"));
at({ "th": { "public": { "sampleString": "\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2A\u0E15\u0E23\u0E34\u0E07" } } });
};